.root {
	position: relative;
	flex-shrink: 0;
}

.trigger {
	display: flex;
	align-items: center;
	gap: 3px;
	height: 30px;
	padding: 0 8px;
	background: transparent;
	border: none;
	border-radius: var(--parrot-chat-radius);
	color: var(--parrot-chat-text-secondary);
	font-family: inherit;
	font-size: var(--parrot-chat-font-size-sm);
	white-space: nowrap;
	cursor: pointer;
	transition: color 0.12s, background 0.12s;
}

.trigger:hover,
.trigger[aria-expanded="true"] {
	color: var(--parrot-chat-text);
	background: var(--parrot-chat-menu-hover);
}

.trigger svg {
	width: 14px;
	height: 14px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
}

/* Opens upward (composer sits at the bottom) and right-aligned to the trigger. */
.menu {
	composes: surface from "../../menu.module.css";
	position: absolute;
	bottom: calc(100% + 8px);
	right: 0;
	min-width: 220px;
	z-index: 5;
	animation: menuIn 0.14s ease-out;
}

.item {
	composes: itemBase from "../../menu.module.css";
	display: flex;
	align-items: flex-start;
	gap: 8px;
}

.item:hover {
	background: var(--parrot-chat-menu-hover);
}

.text {
	display: flex;
	flex-direction: column;
	gap: 1px;
	min-width: 0;
}

.label {
	color: var(--parrot-chat-text);
	font-weight: var(--parrot-chat-font-weight-medium);
}

.desc {
	color: var(--parrot-chat-text-muted);
	font-size: var(--parrot-chat-font-size-sm);
	line-height: 1.35;
}

.check {
	display: flex;
	align-items: center;
	width: 16px;
	height: 20px;
	flex-shrink: 0;
	color: var(--parrot-chat-accent);
}

.check svg {
	width: 16px;
	height: 16px;
	fill: none;
	stroke: currentColor;
	stroke-width: 2.5;
	stroke-linecap: round;
	stroke-linejoin: round;
}

@keyframes menuIn {
	from {
		opacity: 0;
		transform: translateY(4px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
